/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { ClipBoardBlock } from 'components';

import systemPreferences from '../../../../assets/macOS/system-preferences.png';
import security from '../../../../assets/macOS/security.png';
import general from '../../../../assets/macOS/general.png';
import openAnyway from '../../../../assets/macOS/open-anyway.png';

export function Installation() {
  return (
    <Card className="mt-3">
      <Card.Header>Installation issues</Card.Header>
      <Card.Body>
        <p>
          To install the Installer on Mac, we need to allow installation of
          third party software. Go ahead and open the downloaded .pkg file, if a
          message is prompted that you can not install the file:
        </p>
        <ol>
          <li className="my-4">
            <p>Open System Preferences:</p>
            <img
              width={700}
              height={400}
              alt="System Preferences"
              src={systemPreferences}
            />
          </li>
          <li className="my-4">
            <p>Continue to Security & Privacy</p>
            <img
              width={700}
              height={400}
              alt="Security & Privacy"
              src={security}
            />
          </li>
          <li className="my-4">
            <p>Open "General" tab:</p>
            <img width={700} height={400} alt="General" src={general} />
          </li>
          <li className="my-4">
            <p>
              There should be a “Open Anyway“ button after you once tried to
              open Installer app.
            </p>
            <img width={700} height={400} alt="Open anyway" src={openAnyway} />
          </li>
          <li>
            <p>
              After clicking the “Open anyway“ button, enter the passwrod and
              proceed with installation
            </p>
          </li>
          <li>
            <Link to="/hardware/installer/installation/Installation">Test</Link>{' '}
            Installer connection again.
          </li>
        </ol>
      </Card.Body>
    </Card>
  );
}

Installation.title = 'Installation issues';

export function Connection() {
  return (
    <Card className="mt-3">
      <Card.Header>Connection issues</Card.Header>
      <Card.Body>
        <p>
          If the Installer is installed properly (
          <Link to="/hardware/installer/troubleshooting/CheckIfInstalled">
            Check here, if the Installer is running properly
          </Link>
          ) but you are still unable to connect to it, the reason might be that{' '}
          <code>SSLEnable</code> or <code>Port</code> values were changed in
          Installer configuration.
        </p>
        <p>To fix that follow the steps below:</p>
        <ol>
          <li>Open your terminal.</li>
          <li>
            Execute the following command
            <ClipBoardBlock className="w-100 my-1">
              cd /Library/Erply/installer2 && sudo nano config.json
            </ClipBoardBlock>
          </li>
          <li>
            You should see the json object with the Installer configurations in
            the terminal. Make sure that <code>SSLEnabled</code> is set to{' '}
            <code>true</code>. <br />
            If it is not, change the value and save, then restart the service
            with{' '}
            <ClipBoardBlock className="w-100 my-1">
              sudo launchctl stop com.Erply.installer2
            </ClipBoardBlock>
          </li>
          <li>
            Then go to{' '}
            <Link to="/hardware/installer/installation/Customization">
              Customization section
            </Link>{' '}
            and make sure that <code>Port</code> there is set to the same value.
            <br />
            Once they match, press the{' '}
            <em>Save Installer Configuration Info</em> button.
          </li>
          <li>
            <Link to="/hardware/installer/installation/Installation">Test</Link>{' '}
            Installer connection again.
          </li>
        </ol>
      </Card.Body>
    </Card>
  );
}

Connection.title = 'Connection issues';

export function CheckIfInstalled() {
  return (
    <Card className="mt-3">
      <Card.Header>
        Check if Installer is installed and running properly
      </Card.Header>
      <Card.Body>
        <p>Follow the steps below:</p>
        <ol>
          <li>Open your terminal.</li>
          <li>
            Execute the following command
            <ClipBoardBlock className="w-100 my-1">
              sudo launchctl list com.Erply.installer2
            </ClipBoardBlock>
            <ul className="m-0 p-0">
              <li>
                Installer is not installed
                <ClipBoardBlock className="w-100" copy={false}>
                  Unit installer.service could not be found.
                </ClipBoardBlock>
              </li>
              <li>
                Installer is installed and stopped
                <ClipBoardBlock className="w-100" copy={false}>
                  installer.service - Erply installer service
                  <br />
                  Loaded: loaded
                  <br />
                  Active: inactive
                </ClipBoardBlock>
              </li>
              <li>
                Installer is Installed and running
                <ClipBoardBlock className="w-100" copy={false}>
                  installer.service - Erply installer service
                  <br />
                  Loaded: loaded
                  <br />
                  Active: active (running)
                </ClipBoardBlock>
              </li>
            </ul>
          </li>
        </ol>
      </Card.Body>
    </Card>
  );
}

CheckIfInstalled.title = 'Check if Installer is installed properly';

export function InstallationCommands() {
  return (
    <Card className="mt-3">
      <Card.Header>Installer App Commands</Card.Header>
      <Card.Body>
        In order to install, start, stop and uninstall the Installer App,
        execute the following commands in the terminal:
        <ul>
          <li>
            Install
            <ClipBoardBlock className="w-100">
              cd /Library/Erply/installer2 && sudo ./installer2_darwin
              -service=install
            </ClipBoardBlock>
          </li>
          <li>
            Start
            <ClipBoardBlock className="w-100">
              sudo launchctl load
              /Library/LaunchDaemons/com.Erply.installer2.plist
            </ClipBoardBlock>
          </li>
          <li>
            Stop
            <ClipBoardBlock className="w-100">
              sudo launchctl unload
              /Library/LaunchDaemons/com.Erply.installer2.plist
            </ClipBoardBlock>
          </li>
          <li>
            Uninstall
            <ClipBoardBlock className="w-100">
              cd /Library/Erply/installer2 && sudo ./installer2_darwin
              -service=uninstall
            </ClipBoardBlock>
          </li>
        </ul>
      </Card.Body>
    </Card>
  );
}
InstallationCommands.title = 'Installer App Commands';
